import { PaginateQuery } from 'core/resources/types/shared';
export interface TipoAnuncioDto {
    id: string;
    nome: string;
}

export interface StatusAnuncioDto {
    id: AnuncioStatusEnum;
    nome: string;
}

export interface PessoaAnuncioDto {
    id: string;
    nome: string;
    imagemUrl?: string | null;
    telefone?: string | null;
    cpf?: string | null;
    email?: string;
}

export interface AnuncioDto {
    id: string;
    nome: string;
    pessoa: PessoaAnuncioDto;
    status: StatusAnuncioDto;
    tipoAnuncio: TipoAnuncioDto;
    dataPublicacao: string;
    imagemUrl?: string | null;
}

export interface AnuncioLog {
    createdAt: string;
    motivo: string;
    status: {
        id: AnuncioStatusEnum;
        nome: string;
    }
    pessoa: {
        id: string;
        nome: string;
    }
}

export interface AnuncioResponse extends AnuncioDto {
    descricao: string;
    valor: number;
    imagens: {
        id: string;
        referencia: string;
        ordem: number;
    }[];
    logs: AnuncioLog[];
}

export interface ListarAnuncioQuery extends PaginateQuery {
    statusId?: AnuncioStatusEnum;
}

export enum AnuncioStatusEnum {
    Pendente = '4A167CFF-B620-4172-BB9B-44DBCD7F18E5',
    Aprovado = 'EF5E09BF-5CA2-4A4E-A6EF-5F0165DDBC5F',
    Rejeitado = '926A3D37-BE7E-47A4-95BF-3214962BDE5E',
    EmAnalise = '4A167CFF-B620-4172-BB9B-44DBCD7F18E6',
}



